<div class="d-flex flex-column justifiy-content-center align-items-center" style="width: 100%; background-color: white; border-radius: 0.5rem; overflow: hidden">
  <!-- <button *ngIf="!isMobile" class="close-btn" (click)="close()" ><span class="fa fa-x"></span></button>  -->
  <div class="my-modal__close" *ngIf="!isMobile" (click)="close()">
    <i class="fa-solid fa-times"></i>
  </div>
  @if (currentCropInformation) {
    <div style="width: 100%; aspect-ratio: 1/1">
      <app-cropped-image [imgSrc]="imageSrc" class="w-100" [cropInformation]="currentCropInformation"></app-cropped-image>
    </div>
  } @else {
    <img loading="lazy" (click)="$event.stopPropagation()" [src]="imageSrc" style="width: 100%; object-fit: cover" />
  }

  <h2 class="p-2" style="font-size: 1.25rem; border-bottom: 1px solid #00000097; width: 100%; text-align: center" *ngIf="title">{{ title }}</h2>

  <div class="descr" *ngIf="descr">"{{ descr }}"</div>
  <div class="price" *ngIf="price">{{ price }}</div>

  <div class="bottom-images" *ngIf="otherImages?.length">
    <ng-container *ngFor="let otherImage of otherImages">
      <div class="bottom-image" (click)="$event.stopPropagation(); changeMainImageTo(otherImage)" *ngIf="otherImage">
        <img [src]="otherImage" />
      </div>
    </ng-container>
  </div>
</div>
